import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from "react-router-dom";
import IndueCardListTable from "./IndueCardListTable";
import { useIndueCardDetailsQuery, useIndueCardsandAssociationsByAccountQuery, } from "generated/generated-models";
import { Loading } from "app/lib/components/Loading";
import { CError } from "app/common/CError";
import { makeNonEmpty } from "core/util/array";
import IndueCardDetailsPage from "./IndueCardDetailsPage";
import { Grid, Button } from "@mui/material";
const IndueCardPage = ({ accountId }) => {
    const { number, cardid } = useParams();
    const { data, loading, error } = useIndueCardDetailsQuery({
        variables: { input: { CardId: cardid } },
        fetchPolicy: "network-only",
    });
    const card = data?.indueCardDetails;
    const { data: dataIndueCards, loading: loadingIndueCards, error: errorIndueCards, } = useIndueCardsandAssociationsByAccountQuery({
        variables: { accountId: accountId, accountIdString: accountId },
        fetchPolicy: "network-only",
    });
    const indueCards = makeNonEmpty(dataIndueCards?.indueCardsByAccount);
    if (loading || loadingIndueCards) {
        return _jsx(Loading, {});
    }
    if (error || errorIndueCards || card == null) {
        return _jsx(CError, { error: "Could not retrieve card details" });
    }
    return (_jsxs("div", { className: "main-content sub-wrap cardPage", children: [_jsx("div", { className: "cards-header", children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 6, children: _jsxs("div", { className: "list-header", children: [_jsx("h2", { children: "Cards" }), _jsxs("span", { className: "list-subhead", children: ["For Account: ", number] })] }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx("div", { className: "quick-actions", children: _jsx(Button, { href: `/account/index/${number}`, variant: "contained", sx: { p: 1.5, mt: 1 }, id: "viewAccountDetailsButton", children: "View Account Details" }) }) })] }) }), _jsxs("div", { className: "cardsContainer", children: [_jsx(IndueCardListTable, { accountNumber: number ?? "", cards: makeNonEmpty(indueCards), handleOnSelectedCard: cardid }), _jsx(IndueCardDetailsPage, { cardId: cardid })] })] }));
};
export default IndueCardPage;
